import axios from 'axios';
import { selectPreferredLanguageCode } from 'tradera-state/language/selectors';
import { toLocalizedUrl } from 'tradera-utils/url';
import {
    initialize,
    setEnvironmentHash,
    setIsSpaNavigationEnabled
} from './reducer';
import { isNextJs } from 'tradera-utils/nextjs';
import { selectMemberId } from 'tradera-state/member/selectors';
import getInitialState from './initial-state';
import {
    createNativeAppCookieValue,
    extractNativeAppInfoFromCookie,
    extractNativeAppInfoFromInitData
} from './native-app-info-helper';
import cookie from 'tradera-utils/cookie';
import { NATIVE_APP_ENVIRONMENT } from 'tradera-constants/cookies';

const getVersionUrl = getState => {
    if (isNextJs) {
        const queryParameters = new URLSearchParams({ next: 1 });
        const memberId = selectMemberId(getState());
        if (memberId) {
            queryParameters.set('memberId', memberId);
        }
        return `/api/version?${queryParameters}`;
    }

    const preferredLanguageCode = selectPreferredLanguageCode(getState());

    return toLocalizedUrl('/ping', preferredLanguageCode);
};

export const updateEnvironmentHash = () => async (dispatch, getState) => {
    const url = getVersionUrl(getState);
    const response = await axios.get(url);
    const environmentHash = response.headers['x-tradera-environment'];
    const current = getState().environment.environmentHash;
    if (environmentHash !== current) {
        dispatch(setEnvironmentHash(environmentHash));
        dispatch(setIsSpaNavigationEnabled(false));
    }
};

const getAndUpdateNativeAppInfo = initData => {
    const nativeAppInfoFromInitData = extractNativeAppInfoFromInitData(
        initData
    );
    const hasAnyValidProperties =
        Object.values(nativeAppInfoFromInitData).filter(Boolean).length > 0;
    if (hasAnyValidProperties) {
        const nativeAppCookieValue = createNativeAppCookieValue(
            nativeAppInfoFromInitData
        );
        cookie.createCookie(NATIVE_APP_ENVIRONMENT, nativeAppCookieValue);
        return nativeAppInfoFromInitData;
    }

    const cookieValue = cookie.readCookie(NATIVE_APP_ENVIRONMENT);
    const nativeAppInfo = extractNativeAppInfoFromCookie(cookieValue);
    return nativeAppInfo;
};

export const initEnvironment = initData => dispatch => {
    const {
        osVersion,
        appDevice,
        appVersion,
        appContext
    } = getAndUpdateNativeAppInfo(initData);
    const {
        environment,
        environmentHash,
        experiments = [],
        featureSwitches,
        geoPublicApiBaseUrl,
        isSinglePageApp,
        splitTests,
        splitTestGroups,
        version,
        webLiveUrl
    } = initData;
    const initialState = getInitialState({
        appOsVersion: osVersion,
        experiments,
        environment,
        environmentHash,
        featureSwitches,
        geoPublicApiBaseUrl,
        hybridAppDevice: appDevice,
        hybridAppVersion: appVersion,
        isNativeAppContext: appContext === 'Native',
        isHybridAppContext: Boolean(appContext),
        isSinglePageApp,
        splitTests,
        splitTestGroups,
        version,
        webLiveUrl
    });
    dispatch(initialize(initialState));
};
